/* ═══════════════════════ ICS-eksport ═══════════════════════
   Genererer en RFC 5545-fil med alle fly, hotell-opphold og
   cruise-events. Importeres direkte i Apple/Google Calendar.

   Tider er "floating local time" (ingen TZID, ingen Z-suffiks):
   "13:50" på avgang fra OSL betyr 13:50 norsk tid; "13:30" på
   ankomst Skagway betyr 13:30 lokal Alaska-tid. Dette er normal
   måte å håndtere reiseplaner i kalendere — viseren ser tider
   som de står ved hver lokasjon.
════════════════════════════════════════════════════════════════ */

const FLIGHTS = [
  {n:"FI319", al:"Icelandair", from:"OSL", to:"KEF", date:"2026-07-17", dep:"13:50", durMin:175, ref:"Z2IIVW", loc:"Oslo Gardermoen (OSL)"},
  {n:"FI697", al:"Icelandair", from:"KEF", to:"YVR", date:"2026-07-17", dep:"17:10", durMin:465, ref:"Z2IIVW", loc:"Keflavík (KEF) — Terminal M"},
  {n:"WS3756",al:"WestJet",    from:"YYC", to:"PDX", date:"2026-08-02", dep:"12:40", durMin:130, ref:"KMXQYA", loc:"Calgary (YYC)"},
  {n:"FI662", al:"Icelandair", from:"PDX", to:"KEF", date:"2026-08-02", dep:"19:05", durMin:455, ref:"Z2IIVW", loc:"Portland (PDX)"},
  {n:"FI322", al:"Icelandair", from:"KEF", to:"OSL", date:"2026-08-03", dep:"10:40", durMin:165, ref:"Z2IIVW", loc:"Keflavík (KEF)"},
];

const HOTELS = [
  {n:"Hyatt Regency Vancouver",  in:"2026-07-17", out:"2026-07-19", ref:"HTL-WBD-994928965", adr:"655 Burrard St, Vancouver"},
  {n:"DoubleTree by Hilton Kamloops", in:"2026-07-26", out:"2026-07-27", ref:"HTL-WBD-914589575", adr:"339 St Paul Street, Kamloops"},
  {n:"Fairmont Jasper Park Lodge", in:"2026-07-27", out:"2026-07-29", ref:"HTL-WBD-914589535", adr:"1 Old Lodge Road, Jasper"},
  {n:"Moose Hotel & Suites Banff", in:"2026-07-29", out:"2026-07-31", ref:"257-5076504", adr:"345 Banff Ave, Banff"},
  {n:"Sheraton Suites Calgary Eau Claire", in:"2026-07-31", out:"2026-08-02", ref:"9020877577572", adr:"255 Barclay Parade SW, Calgary"},
];

const CRUISE_KEY = [
  {sum:"🚢 Embarkering Celebrity Solstice", date:"2026-07-19", start:"16:00", durMin:120, loc:"Vancouver Cruise Terminal (Canada Place)", desc:"Booking 6158158 · AquaClass lugar 1563, Dekk 11. Innsjekk åpner ofte 12:00."},
  {sum:"🛳️ Debarkering Vancouver", date:"2026-07-26", start:"06:00", durMin:120, loc:"Vancouver Cruise Terminal", desc:"Avstigning ~06:00–08:00. Hent biltur fra AVIS Hornby St."},
];

const PORTS = [
  {sum:"⚓ Icy Strait Point — havnedag", date:"2026-07-21", arr:"13:30", dep:"22:00", aboard:"21:30", loc:"Wilderness Landing Pier, Hoonah, Alaska", desc:"All-aboard 21:30. SkyGlider kabelbane fra pier inkl. Whale watching, ZipRider, Duck Point Trail."},
  {sum:"⚓ Skagway — havnedag", date:"2026-07-22", arr:"07:00", dep:"20:00", aboard:"19:30", loc:"Railroad Dock / Broadway Dock, Skagway", desc:"All-aboard 19:30. White Pass Railway, Klondike Gold Rush NHP, Dewey Lakes Trail."},
  {sum:"⚓ Juneau — havnedag", date:"2026-07-23", arr:"13:30", dep:"20:30", aboard:"20:00", loc:"Franklin Dock / AJ Dock, Juneau", desc:"All-aboard 20:00. Mendenhall Glacier, Mount Roberts Tramway, helikopter+isbreving."},
  {sum:"⚓ Ketchikan — havnedag", date:"2026-07-24", arr:"13:30", dep:"20:00", aboard:"19:30", loc:"Berth 1-4, Ketchikan", desc:"All-aboard 19:30. Creek Street, Misty Fjords floatplane, Totem Heritage Centre."},
];

/* ── Helpers ── */
function pad(n){ return String(n).padStart(2,"0"); }
function dateBasic(yyyymmdd){ return yyyymmdd.replace(/-/g,""); }
function timeBasic(hhmm){ return hhmm.replace(":","")+"00"; }
function addMinutesLocal(yyyymmdd, hhmm, mins){
  const [y,m,d]=yyyymmdd.split("-").map(Number);
  const [hh,mm]=hhmm.split(":").map(Number);
  // Treat as UTC just for arithmetic — we never serialize as UTC
  const dt=new Date(Date.UTC(y,m-1,d,hh,mm)+mins*60000);
  return dateBasic(`${dt.getUTCFullYear()}-${pad(dt.getUTCMonth()+1)}-${pad(dt.getUTCDate())}`)+"T"+pad(dt.getUTCHours())+pad(dt.getUTCMinutes())+"00";
}
function escapeIcs(s){
  return String(s).replace(/\\/g,"\\\\").replace(/;/g,"\\;").replace(/,/g,"\\,").replace(/\n/g,"\\n");
}
function nextDay(yyyymmdd){
  const [y,m,d]=yyyymmdd.split("-").map(Number);
  const dt=new Date(Date.UTC(y,m-1,d+1));
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth()+1)}-${pad(dt.getUTCDate())}`;
}

/* ── Build ── */
function buildIcs(){
  const lines=[
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Reiseapp//Canada-Alaska-2026//NO",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "X-WR-CALNAME:Canada & Alaska 2026",
    "X-WR-TIMEZONE:Floating",
  ];

  const stamp=new Date().toISOString().replace(/[-:]/g,"").replace(/\.\d+/,"");

  const ev=(uid,sum,startLocal,endLocal,loc,desc,allDay)=>{
    const out=["BEGIN:VEVENT",`UID:${uid}@kolakowski-reiseapp`,`DTSTAMP:${stamp}`];
    if(allDay){
      out.push(`DTSTART;VALUE=DATE:${startLocal}`);
      out.push(`DTEND;VALUE=DATE:${endLocal}`);
    } else {
      out.push(`DTSTART:${startLocal}`);
      out.push(`DTEND:${endLocal}`);
    }
    out.push(`SUMMARY:${escapeIcs(sum)}`);
    if(loc) out.push(`LOCATION:${escapeIcs(loc)}`);
    if(desc) out.push(`DESCRIPTION:${escapeIcs(desc)}`);
    out.push("BEGIN:VALARM","TRIGGER:-PT2H","ACTION:DISPLAY","DESCRIPTION:Reminder","END:VALARM");
    out.push("END:VEVENT");
    return out;
  };

  // Fly
  FLIGHTS.forEach(f=>{
    const start=`${dateBasic(f.date)}T${timeBasic(f.dep)}`;
    const end=addMinutesLocal(f.date,f.dep,f.durMin);
    lines.push(...ev(
      `flight-${f.n}`,
      `✈️ ${f.n} ${f.from}→${f.to}`,
      start, end,
      f.loc,
      `${f.al} · Booking ${f.ref} · Varighet ${Math.floor(f.durMin/60)}t ${f.durMin%60}m`,
      false
    ));
  });

  // Hotell — all-day events. DTEND er ekslusiv → siste natt = utsjekk-dato.
  HOTELS.forEach(h=>{
    lines.push(...ev(
      `hotel-${h.ref.replace(/[^a-z0-9]/gi,"")}`,
      `🏨 ${h.n}`,
      dateBasic(h.in), dateBasic(h.out),
      h.adr,
      `Booking ${h.ref} · Inn ${h.in} · Ut ${h.out}`,
      true
    ));
  });

  // Cruise key events
  CRUISE_KEY.forEach((c,i)=>{
    const start=`${dateBasic(c.date)}T${timeBasic(c.start)}`;
    const end=addMinutesLocal(c.date,c.start,c.durMin);
    lines.push(...ev(`cruise-key-${i}`,c.sum,start,end,c.loc,c.desc,false));
  });

  // Port days — én event pr havnedag fra arrival til all-aboard
  PORTS.forEach((p,i)=>{
    const start=`${dateBasic(p.date)}T${timeBasic(p.arr)}`;
    const end=`${dateBasic(p.date)}T${timeBasic(p.aboard)}`;
    lines.push(...ev(
      `cruise-port-${i}`,
      p.sum,
      start, end,
      p.loc,
      `Ankomst ${p.arr} · All-aboard ${p.aboard} · Avgang ${p.dep}\n\n${p.desc}`,
      false
    ));
  });

  lines.push("END:VCALENDAR");
  return lines.join("\r\n")+"\r\n";
}

/* ── Public API ── */
export function downloadICS(){
  const ics=buildIcs();
  const blob=new Blob([ics],{type:"text/calendar;charset=utf-8"});
  const url=URL.createObjectURL(blob);
  const a=document.createElement("a");
  a.href=url; a.download="canada-alaska-2026.ics";
  document.body.appendChild(a); a.click();
  setTimeout(()=>{ document.body.removeChild(a); URL.revokeObjectURL(url); },100);
}
